import React from 'react';
import cx from 'classnames';

export default class View extends React.PureComponent {
  render() {
    const { className, css, tag: Tag, $disable, ...restProps } = this.props;
    if ($disable) {
      return null;
    }
    return <Tag className={cx(css, cx(className))} {...restProps} />;
  }
}

View.defaultProps = {
  tag: 'div'
};
